import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const HomeSolutions = () => {
    return (
        <section data-scrollax-parent="true" id="KPIs">
            <div className="section-subtitle" data-scrollax="properties: { translateY: '-250px' }" ><span>//</span>highlights </div>
            <div className="container">
                <div className="section-title fl-wrap">
                    <h3>KPIs</h3>
                    <h2>CyberSecOps <span> HIGHLIGHTS</span></h2>
          
                </div>
                <div className="process-wrap fl-wrap">
                    <ul>
                        <li>
                            <div className="time-line-icon">
                                <i className="fab pragicts-security-assurance-icon"></i>
                            </div>
                            <h4>Zero Compromises in Cybersecurity</h4>
                            <div className="process-details">
                                {/* <h6>Duis autem vel eum iriure dolor</h6> */}
                                <p>We pride ourselves on maintaining a flawless record with zero incidents of compromise among the clients we serve, ensuring their security is never compromised.</p>
                                {/* <a href="#">More Details</a> */}
                            </div>
                            <span className="process-numder">01.</span>
                        </li>
                        <li>
                            <div className="time-line-icon">
                                <i className="fal pragicts-team-expertise-icon"></i>
                            </div>
                            <h4>Unparalleled Collective Expertise</h4>
                            <div className="process-details">
                                {/* <h6>In ut odio libero, at vulputate urna. </h6> */}
                                <p>Our team's collective expertise spans software engineering, ITOps, and CloudOps, offering comprehensive coverage and rigorous due diligence in all aspects of cybersecurity.</p>
                                {/* <a href="#">More Details</a> */}
                            </div>
                            <span className="process-numder">02.</span>
                        </li>
                        <li>
                            <div className="time-line-icon">
                                <i className="fal pragicts-delivery-track-record-icon"></i>
                            </div>
                            <h4>Proven Track Record</h4>
                            <div className="process-details">
                                {/* <h6>Nulla posuere sapien vitae lectus suscipit</h6> */}
                                <p>With a demonstrable track record, we boast a referenceable client base, providing tangible evidence of our commitment to excellence in cybersecurity.</p>
                                {/* <a href="#">More Details</a> */}
                            </div>
                            <span className="process-numder">03.</span>
                        </li>
                        <li>
                            <div className="time-line-icon">
                                <i className="fal pragicts-global-partnerships-icon"></i>
                            </div>
                            <h4>Strategic Global Partnerships</h4>
                            <div className="process-details">
                                {/* <h6>Nulla posuere sapien vitae lectus suscipit</h6> */}
                                <p>We have forged strategic partnerships with industry-leading organizations recognized in the Gartner Magic Quadrant, ensuring access to cutting-edge solutions and insights</p>
                                {/* <a href="#">More Details</a> */}
                            </div>
                            <span className="process-numder">04.</span>
                        </li>
                        <li>
                            <div className="time-line-icon">
                                <i className="fal pragicts-certified-staff-icon"></i>
                            </div>
                            <h4>Certified Professionals</h4>
                            <div className="process-details">
                                {/* <h6>Nulla posuere sapien vitae lectus suscipit</h6> */}
                                <p>Our staff undergo certification processes from esteemed institutions such as CompTIA, CISCO, Palo Alto, Check Point, and Fortinet, ensuring they possess definitive expertise in cybersecurity.</p>
                                {/* <a href="#">More Details</a> */}
                            </div>
                            <span className="process-numder">05.</span>
                        </li>
                    </ul>
                </div>
            </div>
           
            <div className="sec-lines"></div>
        </section>
    )
}

export default HomeSolutions
